import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { appIndexUri } from 'kts-platform-frame/entry/configUtils';
// import UIHead from './UI.Head';
// import UIList from './UI.List';
import AppSdk from 'kts-platform-frame/appSdk';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Guide extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount = () => {
        ModulesAction.getAppList();
        AppSdk.instance.initialization();
    }

    render() {
        const url = appIndexUri('Kingxunlian.Initialize');
        return (
            <ModulesRoot action={ModulesAction}>
                <div className={css.appListContainer}>
                    <div className={css.header}>
                        <img src={require('./logo.svg')} />
                    </div>
                    <iframe
                        style={{ width: '100%', height: 'calc(100vh - 50px)', position: 'absolute', bottom: 0, borderWidth: 0 }}
                        src={`${url}`}
                    />
                    {/* <UIHead />
                    <UIList /> */}
                </div>

            </ModulesRoot>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/GettingStarted/index.tsx